module.exports = __webpack_public_path__ + "img/dpsy-icon-liangx.f2d1f60d.png";